<script>
  export default {
    name: 'VisionneuseImages',
    props: {
      donnees: {
        type: Array,
        required: true,
        default: () => [],
      },
      categorie: {
        type: String,
        required: true,
      },
      compteurInitial: {
        type: Number,
        required: true,
        default: 0,
      },
    },
    data() {
      return {
        compteur: this.compteurInitial,
      }
    },
    computed: {
      imageCourante() {
        return this.donnees.length
          ? this.donnees[this.compteur]
          : { image: 'erreur' }
      },
      encartPresent() {
        return this.imageCourante.titre || this.imageCourante.description
      },
      tailleImage() {
        return this.encartPresent ? 'image-avec-encart' : 'image-entiere'
      },
      estEcranLarge() {
        return window.innerWidth > 768
      },
    },
    mounted() {
      window.addEventListener('keydown', this.gererNavigationClavier)
    },
    beforeUnmount() {
      window.removeEventListener('keydown', this.gererNavigationClavier)
    },
    methods: {
      gererNavigationClavier(event) {
        if (event.key === 'ArrowRight') {
          this.augmenterCompteur()
        }
        if (event.key === 'ArrowLeft') {
          this.diminuerCompteur()
        }
        if (event.key === 'Escape') {
          this.fermerVisionneuse('fermer')
        }
      },
      augmenterCompteur() {
        if (this.compteur + 1 > this.donnees.length - 1) {
          this.compteur = 0
        } else {
          this.compteur++
        }
      },
      diminuerCompteur() {
        if (this.compteur - 1 < 0) {
          this.compteur = this.donnees.length - 1
        } else {
          this.compteur--
        }
      },
      fermerVisionneuse(event) {
        if (
          event.target === event.currentTarget ||
          event.target.closest('#croix-fermeture') ||
          event === 'fermer'
        ) {
          this.$emit('fermerVisionneuse')
        }
      },
    },
    emits: ['fermerVisionneuse'],
  }
</script>

<template>
  <div v-if="estEcranLarge" id="visionneuse" @click="fermerVisionneuse">
    <div id="croix-fermeture" @click="fermerVisionneuse">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        fill="white"
        class="bi bi-x"
        viewBox="0 0 16 16"
      >
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
        ></path>
      </svg>
    </div>
    <div @click="diminuerCompteur" class="fleche fleche-gauche">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        fill="white"
        class="fleche fleche-gauche"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
        ></path>
      </svg>
    </div>

    <div id="bloc-image">
      <img
        id="image-visionnee"
        :class="tailleImage"
        :src="`/visuels/${this.categorie}/big/${imageCourante.image}`"
      />
      <div v-if="encartPresent" id="encart">
        <h2 v-if="imageCourante?.titre">{{ imageCourante.titre }}</h2>
        <p v-if="imageCourante?.description" id="description">
          {{ imageCourante.description }}
        </p>
      </div>
    </div>

    <div @click="augmenterCompteur" class="fleche fleche-droite">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        fill="white"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"
        ></path>
      </svg>
    </div>
  </div>

  <div v-else id="visionneuse" @click="fermerVisionneuse">
    <div id="croix-fermeture" @click="fermerVisionneuse">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="70"
        height="70"
        fill="white"
        class="bi bi-x"
        viewBox="0 0 16 16"
      >
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
        ></path>
      </svg>
    </div>

    <div id="bloc-image">
      <img
        id="image-visionnee"
        :class="tailleImage"
        :src="`/visuels/${this.categorie}/big/${imageCourante.image}`"
      />
      <div v-if="encartPresent" id="encart">
        <h2 v-if="imageCourante?.titre">{{ imageCourante.titre }}</h2>
        <p v-if="imageCourante?.description" id="description">
          {{ imageCourante.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
  #visionneuse {
    position: fixed;
    top: 0;
    z-index: 5;
    background-color: rgba(0, 0, 0, 0.95);
    width: 100vw;
    height: 100vh;
    overscroll-behavior: contain;
  }

  #bloc-image {
    display: inline-block;
  }

  .image-avec-encart {
    height: 90vh;
  }

  .image-entiere {
    height: 100vh;
  }

  #encart {
    height: 10vh;
    background-color: white;
    text-align: start;
    display: flex;
    flex-direction: column;
    padding-left: 2em;
    justify-content: center;
  }

  h2 {
    font-weight: 400;
    font-size: 30px;
  }

  p {
    font-size: 1.2em;
  }

  .fleche {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .fleche-droite {
    right: 5%;
  }
  .fleche-gauche {
    left: 5%;
  }

  #croix-fermeture {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    margin-right: 1em;
  }

  @media (max-width: 768px) {
    #visionneuse {
      background-color: black;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    #croix-fermeture {
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      margin-right: 0.2em;
    }

    #bloc-image {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
    }

    #image-visionnee {
      object-fit: contain;
      max-height: 100vh;
      max-width: 100vw;
    }

    #encart {
      position: absolute;
      bottom: 0;
      width: 100vw;
      height: 30vh;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));

      h2 {
        color: white;
        font-size: 20px;
        margin-bottom: 0.5em;
      }

      p {
        color: rgb(200, 200, 200);
        font-size: 16px;
      }
    }
    .image-avec-encart {
      height: 100vh;
    }
  }
</style>
